import { OnboardingFlow } from '@mondaygpt/constants'

/**
 * Per-flow content for the new dark/acid onboarding.
 *
 * The flow STRUCTURE is the same for everyone:
 *   presence → scanning → confirm → paywall → done.
 *
 * `showGoogleBusinessField`/`showGoogleBusinessConnect` are kept on the
 * type for the universal `PresenceStep` to read, even though no flow
 * currently turns them on (the Reputation flow that used them was
 * removed in main).
 */
export interface FlowChrome {
  /** Eyebrow label rendered above the Presence step title. */
  presenceEyebrow: string
  /** Add a Google Business row to the Presence step (above the universal channels). */
  showGoogleBusinessField: boolean
  /** Render the secondary "Connect Google Business" button on the Presence step. */
  showGoogleBusinessConnect: boolean
}

const DEFAULT_CHROME: FlowChrome = {
  presenceEyebrow: 'Welcome',
  showGoogleBusinessField: false,
  showGoogleBusinessConnect: false,
}

const FLOW_CHROME: Record<OnboardingFlow, FlowChrome> = {
  [OnboardingFlow.Default]: DEFAULT_CHROME,
  [OnboardingFlow.Social]: { ...DEFAULT_CHROME, presenceEyebrow: 'Instagram' },
}

export const getFlowChrome = (flow: OnboardingFlow | undefined): FlowChrome =>
  FLOW_CHROME[flow ?? OnboardingFlow.Default] ?? DEFAULT_CHROME
